const volunteerinfo = [
    { 
        volunteerEvent: "Navratri & Durga Puja",
        date: "October 12, 2026",
        roomSpace: "Vitruvian Space, Firmitas A & B (DC12A & DC14)",
        building: "Dining Centre, University of Calgary",
        setup: "4:00pm - 5:30pm",
        cleanup: "9:00pm - 10:00pm",
    }                   
];

export default volunteerinfo;
